/**
 * @file index.tsx
 *
 * @fileoverview This is the login page and is accessed by going to "/user/login".
 * The page displays a form for the user to provide username and password
 * and on submit will make a call to log the user in.
 */
import { NextPage } from 'next';
import { Login } from '~/jobiqo/components/User/Login';
import { withAuthenticateAnonymous } from '~/jobiqo/hocs/withAuthenticate/anonymous';
import { getServerFrontendConfig } from '~/jobiqo/lib/frontendConfig';
import { gsspRedirect } from '~/jobiqo/lib/redirect';

export interface LoginPageProps {}
export const LoginPage: NextPage<LoginPageProps, {}> = ({}) => {
  return <Login />;
};
export const getServerSideProps = withAuthenticateAnonymous({
  gssp: async (ctx) => {
    const frontendConfig = getServerFrontendConfig();
    const APPLICANT_FEATURE_ACTIVE =
      frontendConfig.RESUME.APPLICANT_FEATURE_ACTIVE;
    const RECRUITER_FEATURE_ACTIVE =
      frontendConfig.ORGANIZATIONS.RECRUITER_FEATURE_ACTIVE;

    // Redirect to the home page if both features are inactive.
    return {
      props: {},
      ...(!APPLICANT_FEATURE_ACTIVE &&
        !RECRUITER_FEATURE_ACTIVE && {
          redirect: {
            destination: gsspRedirect(ctx, '/'),
            permanent: false,
          },
        }),
    };
  },
});

export default LoginPage;
